/*
Documentation on well-known events in Gtag / GA:

  https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag
  https://developers.google.com/tag-platform/gtagjs/reference/events

We should prefer well-known events, with well-known properties.
*/

// Standard / predefined GA events.
export const GTAG_EVENT_LOGIN = `login`
export const GTAG_EVENT_SIGN_UP = `sign_up`
export const GTAG_EVENT_PAGE_VIEW = `page_view`
export const GTAG_EVENT_BEGIN_CHECKOUT = `begin_checkout`
export const GTAG_EVENT_PURCHASE = `purchase`
export const GTAG_EVENT_VIEW_ITEM = `view_item`
export const GTAG_EVENT_VIEW_ITEM_LIST = `view_item_list`
export const GTAG_EVENT_VIEW_SEARCH_RESULTS = `view_search_results` // TODO use.

// Miscellaneous non-standard events.
export const GTAG_EVENT_EMAIL_SUBSCRIPTION = `email_subscription`
export const GTAG_EVENT_PAGE_UNLOAD = `page_unload`

// GA defines a login event, but not a logout event.
export const GTAG_EVENT_LOGOUT = `logout`

/*
Non-standard event that indicates that a user attempted to make a purchase, but
the purchase flow is interrupted for some necessary action, such as login or
selecting a date-time.

TODO find a matching standard event.
*/
export const GTAG_EVENT_PURCHASE_PRECONDITION = `purchase_precondition`

/*
Non-standard event. We had to define this because GA doesn't predefine ANY
events for users creating content. GA thinks users are stupid and can only
consume.
*/
export const GTAG_EVENT_CREATE = `create`

// Similar to our SQL enum `payment_provider`, but not an exact match.
export const PAYMENT_PROVIDER_INTERNAL = `internal`
export const PAYMENT_PROVIDER_STRIPE = `stripe`
export const PAYMENT_PROVIDER_PAYPAL = `pay_pal`
export const PAYMENT_PROVIDER_PAYPAL_DIRECT = `pay_pal_direct`

export const PAYMENT_PROVIDER_SUBTYPE_STRIPE_SINGLE = `stripe_single`
export const PAYMENT_PROVIDER_SUBTYPE_STRIPE_RECURRENT = `stripe_recurrent`
export const PAYMENT_PROVIDER_SUBTYPE_STRIPE_EXPRESS_SINGLE = `stripe_express_single`
export const PAYMENT_PROVIDER_SUBTYPE_STRIPE_EXPRESS_RECURRENT = `stripe_express_recurrent`
export const PAYMENT_PROVIDER_SUBTYPE_PAYPAL_SINGLE = `pay_pal_single`
export const PAYMENT_PROVIDER_SUBTYPE_PAYPAL_RECURRENT = `pay_pal_recurrent`
export const PAYMENT_PROVIDER_SUBTYPE_PAYPAL_DIRECT_SINGLE = `pay_pal_direct_single`
